import moment from "moment";
// import posix from 'path-browserify';

const getDate = time => {
  return moment(time).format("YYYY-MM-DD");
};
//处理表单返回文本以及提示
const manageJson = json => {
  const changeJson = JSON.parse(json);
  if (changeJson instanceof Array) {
    return json;
  } else {
    return changeJson;
  }
};
const getClientSettings = () => {
  try {
    return JSON.parse(localStorage.getItem("settings") || "{}");
  } catch (e) {
    return {};
  }
};

//处理静态文件
const getStaticUrl = path => {
  if (!path) {
    return "";
  }
  if (path.indexOf("http://") === 0 || path.indexOf("https://") === 0) {
    return path;
  }
  if (path.indexOf("oss://") === 0) {
    return getS3Url(path);
  }
};
const getS3Url = path => {
  const settings = getClientSettings();
  if (!path) {
    return "";
  }
  if (path.indexOf("http://") === 0 || path.indexOf("https://") === 0) {
    return path;
  }
  if (path.indexOf("oss://") === 0) {
    const [ossBucket, ossPath] = path.slice("oss://".length).split(":");
    // return `https://${ossBucket}.${ app.globalData.oss.imgur}/${ossPath}`;
    return `http://${ossBucket}.${settings?.fs?.oss?.imgur}/${ossPath}`;
  }
  if (
    path.indexOf("http://") === -1 &&
    path.indexOf("https://") === -1 &&
    path.indexOf("oss://") === -1
  ) {
    return `${settings?.fs?.oss?.imgur}${path}`;
  }
  return "";
};

//处理字符串的html片段
const disposeHtml = text => {
  if (text && text != "") {
    const html = text.replace(/<[^>]+>/g, "");
    html.replace(/&nbsp;/gi, "");
    return html;
  }
};
//判断三级数据是否存在
const existData = (data, index, text) => {
  if (data instanceof Object) {
    if (data[index] == "" || data[index] == undefined || data[index] == null) {
      return "";
    } else {
      return `${text}${data[index]}`;
    }
  }
  if (data instanceof Array) {
    if (data && data.length > 0) {
      let defindData = {};
      defindData = data[0];
      if (
        defindData[index] == "" ||
        defindData == undefined ||
        data[index] == null
      ) {
        return "";
      } else {
        return `${text}${defindData[index]}`;
      }
    }
  } else {
    return "";
  }
};
//路由跳转
const toRouters = (_this, href, tab) => {
  if (tab) {
    _this.$router.push({
      path: href,
      query: tab
    });
  } else {
    _this.$router.push(href);
  }
};
//判断当前是否登录
const userLogin = () => {
  const token = JSON.parse(localStorage.getItem("token"));
  if (token && token.accessToken) {
    return true;
  }
};

const parseRemindMessage = (message, ...msgAttrs) => {
  /**
   * 匹配<a>标签，并且分割成['xxx','<a objectType="yyy">zzz</a>','abc','def']这样的数组
   */
  const matches = [...message.matchAll(/(<a[^>]*>((?!<a[^>]*>).)+<\/a>)/g)];
  const splits = [];
  matches.forEach(match => {
    splits.push(message.slice(splits.join("").length, match.index));
    splits.push(message.substr(splits.join("").length, match[0].length));
  });
  splits.push(message.slice(splits.join("").length));

  return splits
    .filter(str => !!str)
    .map((str, index) => {
      /**
       * 匹配a标签并生成超链接
       */
      const matchInfo = str.match(
        /^<a(\s+\w+=".+"|\s+\w+='.+')*[^>]*>(.+)<\/a>$/
      );
      if (matchInfo) {
        const attrs = { ...msgAttrs };
        const [, linkAttrStr, linkText] = matchInfo;
        if (linkAttrStr) {
          // 提取a标签所有属性
          linkAttrStr.match(/\w+="([^'"]*)"/g)?.forEach(r => {
            const [attrKey, attrVal] = r.split("=");
            attrs[attrKey] = attrVal.slice(1, -1);
          });
        }
        return linkText;
      }

      return <span key={index}>{str}</span>;
    });
};
export default {
  getDate,
  manageJson,
  getStaticUrl,
  getS3Url,
  getClientSettings,
  disposeHtml,
  existData,
  toRouters,
  userLogin,
  parseRemindMessage
};
